import React, { useEffect, useState, useContext } from "react";
import Input from "../../shared/components/Input";
import {
  VALIDATOR_NUMBER_ONLY,
  VALIDATOR_REQUIRE,
  VALIDATOR_VALIDATED,
} from "../../shared/util/validators";
import useForm from "../../shared/hooks/form-hooks";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Unstable_Grid2";
import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";

import CircularProgress from "@mui/material/CircularProgress";
import { AuthContext } from "../../context/AuthContext";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { baseUrl } from "../../baseUrl";

const OrderTypeEdit = (props) => {
  const [isLoading, setIsLoading] = useState(false);

  const auth = useContext(AuthContext);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const [formState, inputHandler, setFormData] = useForm(
    {
      name: {
        value: props.name,
        isValid: false,
      },
      unitPrice: {
        value: props.unitPrice,
        isValid: false,
      },
      oneJawPrice: {
        value: props.oneJawPrice,
        isValid: false,
      },
      twoJawPrice: {
        value: props.twoJawPrice,
        isValid: false,
      },
    },
    false
  );

  useEffect(() => {
    setFormData(
      {
        name: {
          value: props.name,
          isValid: true,
        },
        unitPrice: {
          value: props.unitPrice,
          isValid: true,
        },
        oneJawPrice: {
          value: props.oneJawPrice,
          isValid: true,
        },
        twoJawPrice: {
          value: props.twoJawPrice,
          isValid: true,
        },
      },
      true
    );
    setIsLoading(false);
  }, [setFormData, props]);

  const orderTypeUpdateHandler = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      const response = await fetch(
        baseUrl + "/api/v1/laboratorys/update-orderType",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            authorization: auth.token,
          },
          body: JSON.stringify({
            id: props.id,
            name: formState.inputs.name.value,
            perUnitPrice: formState.inputs.unitPrice.value,
            jawPrice: formState.inputs.oneJawPrice.value,
            twoJawPrice: formState.inputs.twoJawPrice.value,
          }),
        }
      );
      const responseData = await response.json();
      console.log(props.id);
      console.log(responseData.message.message);
      if (!response.ok) {
        throw new Error(responseData.message);
      } else {
        enqueueSnackbar(responseData.message.message, {
          variant: "success",
        });
      }
      setIsLoading(false);
      dispatch({
        type: "update_order_types",
      });
    } catch (err) {
      setIsLoading(false);
      err &&
        err.data.forEach((error) =>
          enqueueSnackbar(error, { variant: "error" })
        );
    }
    props.close();
  };

  if (isLoading) {
    return (
      <div style={{ justifyContent: "center", display: "flex" }}>
        <CircularProgress color="inherit" />
      </div>
    );
  }
  return (
    <React.Fragment>
      <form onSubmit={orderTypeUpdateHandler}>
        <Paper sx={{ flexGrow: 1, maxWidth: 1200, p: 2, m: 1 }} elevation={2}>
          <Grid container spacing={1}>
            <Grid md={6} xs={12}>
              <Input
                id="name"
                element="input"
                label="نام"
                validators={[VALIDATOR_REQUIRE()]}
                errorText="لطفا نام کار را وارد کنید"
                initialValue={formState.inputs.name.value}
                inputValid={formState.inputs.name.isValid}
                onInput={inputHandler}
              />
            </Grid>
            <Grid md={6} xs={12}>
              <Input
                id="unitPrice"
                element="number_only"
                label="قیمت هر واحد"
                validators={[VALIDATOR_VALIDATED(), VALIDATOR_NUMBER_ONLY()]}
                errorText="لطفا قیمت هر واحد را به درستی وارد کنید"
                initialValue={formState.inputs.unitPrice.value}
                inputValid={formState.inputs.unitPrice.isValid}
                onInput={inputHandler}
                type="text"
                needsThousandSeparator
                inputProps={{
                  min: 0,
                }}
              />
            </Grid>
            <Grid md={6} xs={12}>
              <Input
                id="oneJawPrice"
                element="number_only"
                label="قیمت یک فک"
                validators={[VALIDATOR_VALIDATED(), VALIDATOR_NUMBER_ONLY()]}
                errorText="لطفا قیمت یک فک را به درستی وارد کنید"
                initialValue={formState.inputs.oneJawPrice.value}
                inputValid={formState.inputs.oneJawPrice.isValid}
                onInput={inputHandler}
                type="text"
                needsThousandSeparator
                inputProps={{
                  min: 0,
                }}
              />
            </Grid>
            <Grid md={6} xs={12}>
              <Input
                id="twoJawPrice"
                element="number_only"
                label="قیمت دو فک"
                validators={[VALIDATOR_VALIDATED(), VALIDATOR_NUMBER_ONLY()]}
                errorText="لطفا قیمت دو فک را به درستی وارد کنید"
                initialValue={formState.inputs.twoJawPrice.value}
                inputValid={formState.inputs.twoJawPrice.isValid}
                onInput={inputHandler}
                type="text"
                needsThousandSeparator
                inputProps={{
                  min: 0,
                }}
              />
            </Grid>
            <Grid xs={12} md={6}>
              <Button
                disabled={!formState.isValid}
                type="submit"
                fullWidth
                color="secondary"
                variant="contained"
              >
                <EditIcon />
              </Button>
            </Grid>
            <Grid xs={12} md={6}>
              <Button
                fullWidth
                color="primary"
                variant="contained"
                onClick={props.close}
              >
                <ArrowBackIcon />
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </form>
    </React.Fragment>
  );
};

export default OrderTypeEdit;
